/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// hooks
import { useAuth } from '../hooks';
// components
import { LoadingScreen } from '../components/loading';

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
    const { isAuthenticated, isInitialized, authInitError } = useAuth();
    const { pathname, search } = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);

    if (!isInitialized) {
        if (authInitError?.retryExhausted) {
            return (
                <Box
                    sx={{
                        px: 3,
                        minHeight: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Stack spacing={2} alignItems="center" textAlign="center">
                        <Typography variant="h6">Connection issue</Typography>
                        <Typography variant="body2" color="text.secondary">
                            We could not reconnect to your session. Your login has been kept on this device.
                        </Typography>
                        <Button variant="contained" onClick={() => window.location.reload()}>
                            Retry
                        </Button>
                    </Stack>
                </Box>
            );
        }
        return <LoadingScreen />;
    }

    if (!isAuthenticated) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <Navigate to={`/auth/login?next=${pathname}${search}`} />;
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <Navigate to={requestedLocation} />;
    }

    return <>{children}</>;
}

AuthGuard.propTypes = {
    children: PropTypes.node,
};
